import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Banknote } from "lucide-react";
import SalairesDashboardTab from "@/components/salaires/SalairesDashboardTab";
import SalairesEmployesTab from "@/components/salaires/SalairesEmployesTab";
import SalairesFichesTab from "@/components/salaires/SalairesFichesTab";
import SalairesComptaTab from "@/components/salaires/SalairesComptaTab";
import SalairesParametresTab from "@/components/salaires/SalairesParametresTab";

export default function Salaires() {
  const [tab, setTab] = useState("dashboard");
  const { user } = useAuth();

  if (user && user.role !== "admin") {
    return (
      <div className="py-16 text-center" data-testid="salaires-acces-refuse">
        <Banknote className="w-10 h-10 text-gray-300 mx-auto mb-3" />
        <h1 className="font-heading text-xl font-bold text-gray-900">Accès réservé</h1>
        <p className="text-sm text-gray-500 mt-1">
          Les données salariales sont accessibles uniquement à l'administrateur.
        </p>
      </div>
    );
  }

  return (
    <div data-testid="salaires-page">
      <div className="mb-5">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-2">
          <Banknote className="w-7 h-7 text-[#52a675]" /> Salaires &amp; RH
        </h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Collaborateurs · fiches de paie · charges sociales · comptabilisation
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="w-full overflow-x-auto justify-start no-scrollbar flex-nowrap">
          <TabsTrigger value="dashboard" data-testid="tab-salaires-dashboard">Tableau de bord</TabsTrigger>
          <TabsTrigger value="employes" data-testid="tab-salaires-employes">Collaborateurs</TabsTrigger>
          <TabsTrigger value="fiches" data-testid="tab-salaires-fiches">Fiches de paie</TabsTrigger>
          <TabsTrigger value="compta" data-testid="tab-salaires-compta">Comptabilisation</TabsTrigger>
          <TabsTrigger value="parametres" data-testid="tab-salaires-parametres">Paramètres</TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard" className="mt-4"><SalairesDashboardTab /></TabsContent>
        <TabsContent value="employes" className="mt-4"><SalairesEmployesTab /></TabsContent>
        <TabsContent value="fiches" className="mt-4"><SalairesFichesTab /></TabsContent>
        <TabsContent value="compta" className="mt-4"><SalairesComptaTab /></TabsContent>
        <TabsContent value="parametres" className="mt-4"><SalairesParametresTab /></TabsContent>
      </Tabs>
    </div>
  );
}
